import { threeDSService } from '@afterpaytouch/portal-api/consumer/threeDS'

/* Selectors */

export const { useFinaliseThreeDSMutation, useInitiateThreeDSMutation } = threeDSService
